var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "price-list" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: {
                cols: "12",
                md: "9",
                xl: "7",
                id: "first-section-" + _vm.priceList.Id
              }
            },
            [
              _c(
                "b-row",
                [
                  _vm.priceList.FixedTerm === false &&
                  _vm.priceList.ProductComponents[0].ThisMonthForFuturePrice
                    ? _c(
                        "b-col",
                        [
                          _c("u", [
                            _vm._v(
                              _vm._s(
                                _vm.priceList.ProductComponents[0]
                                  .ThisMonthForFuturePrice
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.priceList.ProductComponents[0].FutureTotalPrice >
                          0
                            ? [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "display-short",
                                    staticStyle: {
                                      "background-color": "#4679B2"
                                    },
                                    attrs: {
                                      id: "next-button-" + _vm.priceList.Id,
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleNextMonth()
                                      }
                                    }
                                  },
                                  [_vm._v(" > ")]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.priceList.ProductComponents[0].Energy1Description
                    ? [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "product-component-detail" },
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.priceList.ProductComponents[0]
                                          .Energy1Description
                                      ) +
                                      "\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.showVat
                                  ? _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getFixedPrice(
                                              _vm.priceList.ProductComponents[0]
                                                .Energy1Price,
                                              2
                                            )
                                          ) +
                                          "\n                                " +
                                          _vm._s(
                                            _vm.priceList.ProductComponents[0]
                                              .Energy1PriceUnit
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getFixedPrice(
                                              _vm.priceList.ProductComponents[0]
                                                .Energy1PriceNoVAT,
                                              2
                                            )
                                          ) +
                                          "\n                                " +
                                          _vm._s(
                                            _vm.priceList.ProductComponents[0]
                                              .Energy1PriceUnit
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.priceList.ProductComponents[0].Energy2Description
                          ? [
                              _c(
                                "b-row",
                                { staticClass: "product-component-detail" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "product-component-detail" },
                                    [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.priceList.ProductComponents[0]
                                                .Energy2Description
                                            ) +
                                            "\n                                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.showVat
                                        ? _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.getFixedPrice(
                                                    _vm.priceList
                                                      .ProductComponents[0]
                                                      .Energy2Price,
                                                    2
                                                  )
                                                ) +
                                                "\n                                    " +
                                                _vm._s(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .Energy2PriceUnit
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        : _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.getFixedPrice(
                                                    _vm.priceList
                                                      .ProductComponents[0]
                                                      .Energy2PriceNoVAT,
                                                    2
                                                  )
                                                ) +
                                                "\n                                    " +
                                                _vm._s(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .Energy2PriceUnit
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "product-component-detail" },
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.priceList.ProductComponents[0]
                                          .BasicDescription
                                      ) +
                                      "\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.showVat
                                  ? _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getFixedPrice(
                                              _vm.priceList.ProductComponents[0]
                                                .BasicPrice,
                                              2
                                            )
                                          ) +
                                          "\n                                " +
                                          _vm._s(
                                            _vm.priceList.ProductComponents[0]
                                              .BasicPriceUnit
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getFixedPrice(
                                              _vm.priceList.ProductComponents[0]
                                                .BasicPriceNoVAT,
                                              2
                                            )
                                          ) +
                                          "\n                                " +
                                          _vm._s(
                                            _vm.priceList.ProductComponents[0]
                                              .BasicPriceUnit
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showVat
                    ? _c("div", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("(Hinnat alv 0%)")) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "product-component-detail" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Voimassa")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatDuration(_vm.contract, _vm.priceList)
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showPriceEstimate(_vm.priceList)
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "product-component-detail" },
                            [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("Hinta-arvio")) +
                                    "\n                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      id:
                                        "priceEstimatePrice" + _vm.priceList.Id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.priceEstimate(_vm.priceList))
                                    )
                                  ]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t(" €/vuosi")) +
                                    "\n                        "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.priceList.FixedTerm === false &&
          _vm.priceList.ProductComponents[0].FutureTotalPrice > 0
            ? _c(
                "b-col",
                {
                  staticClass: "display-long",
                  attrs: {
                    cols: "12",
                    md: "9",
                    xl: "5",
                    id: "second-section-" + _vm.priceList.Id
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _vm.priceList.ProductComponents[0].NextMonthForFuturePrice
                        ? _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "display-short",
                                  staticStyle: {
                                    "background-color": "#4679B2",
                                    "font-size": "8px"
                                  },
                                  attrs: {
                                    id: "back-button-" + _vm.priceList.Id
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleNextMonth()
                                    }
                                  }
                                },
                                [_vm._v(" < ")]
                              ),
                              _vm._v(" "),
                              _c("u", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceList.ProductComponents[0]
                                      .NextMonthForFuturePrice
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.priceList.ProductComponents[0].FutureTotalPrice > 0
                        ? [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "product-component-detail" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "title display-short" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.priceList.ProductComponents[0]
                                                .Energy1Description
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showVat
                                      ? _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getFixedPrice(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .FutureEnergy1Price,
                                                  2
                                                )
                                              ) +
                                              "\n                                " +
                                              _vm._s(
                                                _vm.priceList
                                                  .ProductComponents[0]
                                                  .Energy1PriceUnit
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getFixedPrice(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .FutureEnergy1PriceNoVAT,
                                                  2
                                                )
                                              ) +
                                              "\n                                " +
                                              _vm._s(
                                                _vm.priceList
                                                  .ProductComponents[0]
                                                  .Energy1PriceUnit
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.priceList.ProductComponents[0]
                              .Energy2Description
                              ? _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "product-component-detail"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "title display-short"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .Energy2Description
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.showVat
                                          ? _c(
                                              "span",
                                              { staticClass: "value" },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.getFixedPrice(
                                                        _vm.priceList
                                                          .ProductComponents[0]
                                                          .FutureEnergy2Price,
                                                        2
                                                      )
                                                    ) +
                                                    "\n                                " +
                                                    _vm._s(
                                                      _vm.priceList
                                                        .ProductComponents[0]
                                                        .Energy2PriceUnit
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "value" },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.getFixedPrice(
                                                        _vm.priceList
                                                          .ProductComponents[0]
                                                          .FutureEnergy2PriceNoVAT,
                                                        2
                                                      )
                                                    ) +
                                                    "\n                                " +
                                                    _vm._s(
                                                      _vm.priceList
                                                        .ProductComponents[0]
                                                        .Energy2PriceUnit
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "product-component-detail" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "title display-short" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.priceList.ProductComponents[0]
                                                .BasicDescription
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showVat
                                      ? _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getFixedPrice(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .FutureBasicPrice,
                                                  2
                                                )
                                              ) +
                                              "\n                                " +
                                              _vm._s(
                                                _vm.priceList
                                                  .ProductComponents[0]
                                                  .BasicPriceUnit
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getFixedPrice(
                                                  _vm.priceList
                                                    .ProductComponents[0]
                                                    .FutureBasicPriceNoVAT,
                                                  2
                                                )
                                              ) +
                                              "\n                                " +
                                              _vm._s(
                                                _vm.priceList
                                                  .ProductComponents[0]
                                                  .BasicPriceUnit
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showVat
                        ? _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("(Hinnat alv 0%)")) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "product-component-detail" },
                            [
                              _c("span", { staticClass: "title wide-hidden" }, [
                                _vm._v("Voimassa")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDuration(
                                      _vm.contract,
                                      _vm.priceList
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showPriceEstimate(_vm.priceList)
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "product-component-detail" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "title wide-hidden" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("Hinta-arvio")) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "value" }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          id:
                                            "priceEstimatePrice" +
                                            _vm.priceList.Id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceEstimate(_vm.priceList)
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t(" €/vuosi")) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("production-type", {
            attrs: {
              "price-list-id": _vm.priceList.Id,
              "is-selected-price-list": _vm.isSelected
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.actions
        ? _c("div", { staticClass: "product-actions mt-2" }, [
            _vm.showSelectButton()
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-outline-default pricelist next-section",
                    class: { active: _vm.isSelected },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.selected(_vm.priceList)
                        _vm.updateStartDatepicker()
                      }
                    }
                  },
                  [
                    _vm.isSelected
                      ? [
                          _c("font-awesome-icon", { attrs: { icon: "check" } }),
                          _vm._v(" Tuote valittu!\n            ")
                        ]
                      : [
                          _vm._v(
                            "\n                Valitse tämä tuote\n            "
                          )
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showOfferSelectButton()
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-outline-default pricelist next-section",
                    class: { active: _vm.isSelectedProduct() },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.selectedOfferProduct(_vm.priceList)
                      }
                    }
                  },
                  [
                    _vm.isSelectedProduct()
                      ? [
                          _c("font-awesome-icon", { attrs: { icon: "check" } }),
                          _vm._v(" Tuote valittu!\n            ")
                        ]
                      : [
                          _vm._v(
                            "\n                Haluan tarjouksen tästä tuotteesta\n            "
                          )
                        ]
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }